import { RoutableTabsLayout, RouterBreadcrumbs } from 'src/router';
import { routes } from './routes';

function Settings() {
  return (
    <>
      <RouterBreadcrumbs routes={routes} />
      <RoutableTabsLayout routes={routes} />
    </>
  );
}

export default Settings;
